import { platformInfo } from '@gem/utils';

import Tasks from 'APP/Tasks';
import { findSecretGroupsAndLoadWelcomes } from 'APP/Tasks/e2ee/findSecretGroupsAndLoadWelcomes';
import { loadUnknownUsersByIds } from 'APP/Tasks/relationships/loadUnknownUsersByIds';
import { ISecretChatAccessRequestUpdatePayloadResponse } from 'APP/model/counter/counterModel.types';
import { SecretChatAccessRequestStatus } from 'APP/model/e2ee/e2eeModel.types';
import Entities from 'STORE';
import { SecretGroup } from 'STORE/Groups/SecretGroup/SecretGroup';

import { GroupsEvent } from '../GroupsEvent';

export class SecretChatRequestAccessUpdate extends GroupsEvent<ISecretChatAccessRequestUpdatePayloadResponse> {
  async process(): Promise<void> {
    const data = this.eventPayload!;

    const group = Entities.GroupsStore.getGroupById(this.groupId);

    if (!group || !(group instanceof SecretGroup)) {
      return;
    }

    await loadUnknownUsersByIds({ usersIds: [data.userId] });

    if (!group.getDevicesRequest(data.deviceId) && group.withMeInAdmins) {
      await Tasks.e2ee.getActiveSecretGroupAccessRequests(group.id);
    }
    group.setDevicesRequestStatus(data.deviceId, data.status);
    group.setChatAccessRequestsCount(data.activeRequestsCount);

    if (
      data.userId === Entities.usersStore?.Me?.id &&
      data.deviceId === platformInfo.deviceId &&
      data.status === SecretChatAccessRequestStatus.Accepted
    ) {
      await findSecretGroupsAndLoadWelcomes([this.groupId]);
    }
  }
}
